
import { computed, defineComponent, ref, watchEffect } from "vue";
import { ErrorMessage, Field } from "vee-validate";
import { useStore } from "vuex";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep1 {
  p1: string;
  p2: string;
  p3: string;
  p4: string;
  p5: string;
  p6: string;
  p7: string;
  fundingAgency: string;
}

export default defineComponent({
  name: "step-1",
  components: {
    ErrorMessage,
    Field,
    DropDownSection,
  },
  setup() {
    const store = useStore();

    const step1 = ref<IStep1>({
      p1: "0",
      p2: "0",
      p3: "0",
      p4: "0",
      p5: "0",
      p6: "0",
      p7: "0",
      fundingAgency: "",
    });

    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const submit = () => {
      if (!submitButtonRef.value) {
        return;
      }
    };

    const isShowFunding = computed(() => {
      return step1.value.p7 === "1";
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      step1.value.fundingAgency = data.data.fundingAgency || "";
      step1.value.p1 = data.data.researchProposals != null && data.data.researchProposals.length >1 && data.data.researchProposals[1].isChecked ? "1" : "0";
      step1.value.p2 = data.data.researchProposals != null && data.data.researchProposals.length >2 &&data.data.researchProposals[2].isChecked ? "1" : "0";
      step1.value.p3 = data.data.researchProposals != null && data.data.researchProposals.length >3 &&data.data.researchProposals[3].isChecked ? "1" : "0";
      step1.value.p4 = data.data.researchProposals != null && data.data.researchProposals.length >4 &&data.data.researchProposals[4].isChecked ? "1" : "0";
      step1.value.p5 = data.data.researchProposals != null && data.data.researchProposals.length >5 &&data.data.researchProposals[5].isChecked ? "1" : "0";
      step1.value.p6 = data.data.researchProposals != null && data.data.researchProposals.length >6 &&data.data.researchProposals[6].isChecked ? "1" : "0";
      step1.value.p7 = data.data.researchProposals != null && data.data.researchProposals.length >7 &&data.data.researchProposals[7].isChecked ? "1" : "0";
    });

    const listDropDownSections = [
         {title: "Research Study Definition", descriptions: [{description:
          " The IRB research proposal is a description of your study plan and must be submitted in the required format. " +
          " The research proposal describes the protocol you will follow beginning with the purpose of the study, research questions, " +
          " background, significance, design, proposed statistical analyses, research methods, and human subject interactions. " +
          " It is important to design your research protocol to account for risks to human subjects. " +
          " The study proposal is supplemented by recruitment materials, consent forms, and data collection instruments." 
        }]},
         
    ]

    return {
      isShowFunding,
      submit,
      submitButtonRef,
      step1,
      listDropDownSections,
    };
  },
});
